import {
  checkUrlForCategory,
  updateUrlWithCategory,
} from "../../07-libs/categoryUrlHash.js";
import scrollToElement from "../../07-libs/scrollToElement.js";

function initializeFaqUrlHash() {
  // Get faq elements
  const elements = document.querySelectorAll(".tx-goldgas-faq");
  // Exit if there are no faq elements
  if (!elements.length) return;

  function init() {
    elements.forEach((element) => {
      listenForCategoryChange(element, (value) => {
        updateCategories(element, value);
        // Get the category that has the value set
        const category = getCategoryButtonFromFromValue(element, value);
        if (!category) return;
        updateUrlWithCategory(category.textContent);
      });
      updateCategoryFromUrl(element);
    });
  }

  function getCategoryButtonsForElement(element) {
    const categoryButtons = element.querySelectorAll(".filter-tabs__item");
    if (!categoryButtons.length) return;
    return categoryButtons;
  }

  function getCategoryButtonContainerFromElement(element) {
    return element.querySelector(".filter-tabs");
  }

  function getCategorySelectFromElement(element) {
    return element.querySelector(".filter-tabs__mobile select");
  }

  function listenForCategoryChange(element, callback) {
    listenForCategoryButtonClick(element, callback);
    listenForCateforySelectChange(element, callback);
  }

  function listenForCategoryButtonClick(element, callback) {
    const container = getCategoryButtonContainerFromElement(element);
    if (!container) return;
    container.addEventListener("click", (event) => {
      let target = event.target;
      while (target && !target.classList.contains("filter-tabs__item")) {
        // Exit if the target is the container
        if (target === container) return;
        target = target.parentNode;
      }
      if (!target || target.classList.contains("tx-goldgas-faq")) return;
      const categoryValue = target.dataset.faqCategory;
      callback(categoryValue);
    });
  }

  function listenForCateforySelectChange(element, callback) {
    const categorySelect = getCategorySelectFromElement(element);
    if (!categorySelect) return;
    categorySelect.addEventListener("change", (event) => {
      callback(event.target.value);
    });
  }

  function updateCategories(element, value) {
    updateCategoryButtons(element, value);
    updateCategorySelect(element, value);
    emitCategoryChangeEvent(element, value);
  }

  function updateCategoryButtons(element, value) {
    const categoryButtons = getCategoryButtonsForElement(element);
    const activeClass = "filter-tabs__item--active";
    if (!categoryButtons) return;
    categoryButtons.forEach((categoryButton) => {
      if (categoryButton.dataset.faqCategory === value) {
        return categoryButton.classList.add(activeClass);
      }
      categoryButton.classList.remove(activeClass);
    });
  }

  function updateCategorySelect(element, value) {
    const categorySelect = getCategorySelectFromElement(element);
    if (!categorySelect) return;
    categorySelect.value = value;
  }

  function updateCategoryFromUrl(element) {
    const categories = getCategoryButtonsForElement(element);
    if (!categories) return;
    const category = checkUrlForCategory(categories);
    if (!category) return;
    const categoryValue = category.dataset.faqCategory;
    updateCategories(element, categoryValue);
    // Use workaround to make sure pagination is updated
    updateCategoryWorkaround(element);
    // Scroll to the element
    scroll(element);
  }

  function getCategoryButtonFromFromValue(element, value) {
    const buttons = getCategoryButtonsForElement(element);
    if (!buttons) return;
    let button = null;
    buttons.forEach((current) => {
      if (current.dataset.faqCategory === value) {
        button = current;
      }
    });
    return button;
  }

  function updateCategoryWorkaround(element) {
    const categoryButtons = getCategoryButtonsForElement(element);
    if (!categoryButtons) return;
    const active = element.querySelector(".filter-tabs__item--active");
    if (!active) return;
    active.classList.remove("filter-tabs__item--active");
    active.click();
  }

  function emitCategoryChangeEvent(element, value) {
    const event = new CustomEvent("faqCategoryChange", {
      detail: {
        value,
      },
    });
    element.dispatchEvent(event);
  }

  function scroll(element) {
    // Check if faqPreventScroll is set to true. This variable is set on the page,
    // so the scroll is only triggered on the first faq element on the page.
    if (window.faqPreventScroll) return;
    // Set the offset to make sure the complete faq element is visible
    const offset = -150;
    scrollToElement(element, offset);
    // Set faqPreventScroll to true, so further scrolls are prevented
    window.faqPreventScroll = true;
  }

  init();
}

export default initializeFaqUrlHash;
